<template>
  <b-sidebar
    :visible="isSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm()"
    @change="updateIsSidebarActive($event)">
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Add New Holidays
        </h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide" />
      </div>

      <!-- BODY -->
      <ValidationObserver
        #default="{ handleSubmit }"
        ref="OtherWorkingAddForm">
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm()">
          <DatePicker
            v-model="otherWorking.date"
            :rules="{ required: true }"
            name="Date"
            label="Date" />
          <TextFieldInput
            v-model="otherWorking.note"
            :rules="{ required: true }"
            name="Note"
            label="Note"
            trim />
          <SelectField
            v-model="otherWorking.userGroupId"
            :options="userGroupCode"
            :rules="{ required: true }"
            name="GroupId"
            form-label="User Group"
            label-option="name"
            return-value="id" />
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2 btn-submit"
              type="submit">
              Add
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              class="btn-submit"
              variant="outline-secondary"
              @click="hide">
              Cancel
            </b-button>
          </div>
        </b-form>
      </ValidationObserver>
    </template>
  </b-sidebar>
</template>

<script>
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import TextFieldInput from '@/components/Form/TextFieldInput.vue'
import SelectField from '@/components/Form/SelectField.vue'
import DatePicker from '@/components/Form/DatePicker.vue'

export default {
  components: { TextFieldInput, SelectField, DatePicker },
  model: {
    prop: 'isSidebarActive',
    event: 'update:is-sidebar-active'
  },
  props: {
    isSidebarActive: {
      type: Boolean,
      default: false
    },
    userGroupCode: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      initialOtherWorking: {
        code: '',
        date: '',
        note: '',
        userGroupId: ''
      },
      otherWorking: {
        code: '',
        date: '',
        note: '',
        userGroupId: ''
      },
      groupData: []
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    updateIsSidebarActive (val) {
      this.$emit('update:is-sidebar-active', val)
    },
    onSubmit () {
      this.$emit('add-working-hours', this.otherWorking)
      // this.$toast({
      //   component: ToastificationContent,
      //   props: {
      //     title: 'Add New Record Successfully',
      //     icon: 'EditIcon',
      //     variant: 'success',
      //     text: `👋 Holidays ID: ${this.otherWorking.whId} has been added`
      //   }
      // })
    },
    resetForm () {
      this.otherWorking = { ...this.initialOtherWorking }
      this.$refs.OtherWorkingAddForm.reset()
    }
  }
}
</script>

<style>

</style>
